import type { ReactNode } from 'react'
import { BuildInfo } from '../../app/StatusBar'
import { ArcaneCircle, Card, Pentacle } from '../../design/components'
import styles from './AuthLayout.module.css'

export interface AuthLayoutProps {
  title: string
  subtitle?: string
  children: ReactNode
  /** Secondary link row under the card. */
  footer?: ReactNode
}

/**
 * The signed-out frame. No bottom navigation — there is nowhere to navigate to
 * yet — and the content sits at the top of the page rather than being centred in
 * it, so the brand and the card start where the eye already is and do not move
 * down the screen as the card grows an error banner.
 */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className={styles.page}>
      <ArcaneCircle size={420} className={styles.circle} />

      <header className={styles.head}>
        <Pentacle size={34} className={styles.sigil} />
        <h1 className={styles.brand}>Harrowgate</h1>
        <p className={styles.tagline}>A Dresden Files companion</p>
      </header>

      <Card variant="fate" label={title} className={styles.card}>
        {subtitle !== undefined && <p className={styles.subtitle}>{subtitle}</p>}
        {children}
      </Card>

      {footer !== undefined && <div className={styles.footer}>{footer}</div>}

      {/* Here as well as on the shell: someone who cannot get past this screen is exactly
          the person who needs to say which build they are looking at. */}
      <BuildInfo />
    </div>
  )
}
